export default "__VITE_ASSET__bw7Kuufo__"